import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.level1,
    margin: "auto 20px",
    flexGrow: "1",
  },
  contentContainer: {
    display: "flex",
    justifyContent: "center"
  },
  logo: {
    display: "block",
    padding: "2rem 0 0.5rem 0",
    marginLeft: "auto",
    marginRight: "auto",
    maxWidth: 100,
  },
  logoContainer: {
    width: "100%"
  },
  circularProgress: {
    position: "absolute",
    top: "20%",
    left: "48%",
    marginTop: -5,
    marginLeft: -5,
  }
}));
